<template>
  <div>
    <div class="flex items-end gap-2 no-localize-translate">
      <h4
        class="font-normal text-slate-900"
        :class="!minified ? 'text-lg lg:text-3xl' : 'text-base lg:text-[1.675rem] leading-[30px]'"
      >
        {{ totalEmissions }}
      </h4>
      <span class="text-xs lg:text-sm font-normal mt-0.5 align-baseline text-[#707C8ECC] no-localize-translate">tCO<sub>2</sub>e</span>
    </div>
    <div class="mt-0.5 whitespace-nowrap text-xs lg:text-sm pt-1">
      <span
        class="text-[10px] lg:text-[12px] border-transparent rounded-md px-1 py-0.5"
        :class="[previousYearMetricsChange > 0 ? 'text-[#E95844] bg-[#E95844]/[.08]' : 'text-[#038153] bg-[#038153]/[.08]']"
      > {{ displayPercentage }}% </span>
      <span class="text-[10px] lg:text-[12px]">from the previous period</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GhgEmissionTotal',

  props: {
    emissions: {
      type: Number,
      required: true,
    },
    metricsChange: {
      type: [Number, String],
      required: true,
    },
    minified: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    displayPercentage() {
      return `${this.previousYearMetricsChange !== 0 ? thousands(this.previousYearMetricsChange) : this.previousYearMetricsChange}`
    },
    previousYearMetricsChange() {
      return this.metricsChange
    },
    totalEmissions() {
      return thousands(this.emissions, 2, true)
    },
  },
}
</script>
